import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getWidgetDataTopLocalLow = async (limit = 6) => {
  const url = `${backendUrl}/api/screener/widgets/top-local-low/?limit=${limit}`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Ошибка при получении top-local-low');
    }

    return await response.json();
  } catch (error) {
    console.error('Ошибка при запросе /api/screener/widgets/top-local-low/:', error);
    throw error;
  }
};
